import { CurrencySymbol } from 'meta/currency'

import { ComponentType, IComponent } from './component'

export enum TicketStatus {
  active = 'active',
  comingSoon = 'comingSoon',
  exhaust = 'exhaust',
  paused = 'paused',
  soldOut = 'soldOut',
}

export enum TicketCartAction {
  add = 'add',
  remove = 'remove',
}

export enum TicketRules {
  transactionMaxQuantity = 'transactionMaxQuantity',
  transactionMinQuantity = 'transactionMinQuantity',
  transactionStep = 'transactionStep',
  transactionMax = 'transactionMax',
}

interface TicketSector {
  name: string
}

interface TicketSaleRules {
  rule: TicketRules
  value: number
}

export interface ITicket extends IComponent<ComponentType.ticket> {
  availableUntil: string
  currency?: CurrencySymbol
  details: string
  id: number
  mapSectorUuid?: string
  orderCodeDescription: string
  presale: string
  presaleNumber: number
  price: string
  priceNumber: number
  show?: boolean
  sector: TicketSector
  status: TicketStatus
  title: string
  typeTicketDescription?: string
  saleRules?: TicketSaleRules[]
}

export interface ITicketGroup {
  id: number
  name: string
  cover?: {
    type: string
    format: string
    url: string
  }
  typeTicketIds: Array<number>
}
